import { render, staticRenderFns } from "./PowerChatTalk.vue?vue&type=template&id=6ba16306&scoped=true"
import script from "./PowerChatTalk.vue?vue&type=script&lang=js"
export * from "./PowerChatTalk.vue?vue&type=script&lang=js"
import style0 from "./PowerChatTalk.vue?vue&type=style&index=0&id=6ba16306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba16306",
  null
  
)

export default component.exports